import { render, staticRenderFns } from "./CouponsHome.vue?vue&type=template&id=c46ac81a&scoped=true"
import script from "./CouponsHome.vue?vue&type=script&lang=js"
export * from "./CouponsHome.vue?vue&type=script&lang=js"
import style0 from "./CouponsHome.vue?vue&type=style&index=0&id=c46ac81a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46ac81a",
  null
  
)

export default component.exports